/**
 * The voice endpoints (`api/voice.py`). A token names exactly one room,
 * `child-<her id>`, and is minted by the API only: hers from her device's
 * sitting (her room is never a parameter), his from his passkey session, one
 * per room. 503 `{need: "voice"}` means the server has no LiveKit configured,
 * and then nothing about voice is drawn.
 */
import { ApiError, get, post } from "../lib/http";

export interface VoiceToken {
  url: string;
  room: string;
  identity: "child" | "tutor";
  token: string;
}

export interface ChildVoiceToken extends VoiceToken {
  /** She is taken right now (her token then carries canPublish). */
  taken: boolean;
}

export interface TutorVoiceState {
  configured: boolean;
  url: string | null;
  taken: { child_id: string; take: string; at: number } | null;
}

export const voiceApi = {
  childToken: () => post<ChildVoiceToken>("/api/v1/child/voice/token"),
  tutorToken: (childId: string) => post<VoiceToken>("/api/v1/tutor/voice/token", { child_id: childId }),
  tutorState: () => get<TutorVoiceState>("/api/v1/tutor/voice/state"),
};

/** The server has no voice: draw nothing, and stop asking. */
export function voiceOff(e: unknown): boolean {
  return e instanceof ApiError && e.status === 503 && e.need === "voice";
}
